import AccountXLogo from '../assets/images/Account-x.png'
import HotelXLogo from '@ifca-root/react-component/src/assets/icons/MainProductLogo/Images/hotel-x-logo.png'
import ContractXLogo from '@ifca-root/react-component/src/assets/icons/MainProductLogo/Images/contract-x-logo.png'

export interface ProductConfig {
  logo: string
  name: string
  shortName: string
  tagline?: string
}

export type EnvironmentType =
  | 'promenadeuat'
  | 'promenade'
  | 'prod'
  | 'noble'
  | 'asia'
  | 'demo'
  | 'training'
  | 'staging'
  | 'prod-ent'
  | 'ent-uat'
  | 'ent-train'
  | 'local'
  | 'local-dev'
  | 'azure'
  | 'axifcadev'
  | 'internal'
  | 'dev-time'
  | 'trial-migration'

const getCurrentEnvironment = (): string => {
  return process.env.REACT_APP_LOCAL_DB || 'local'
}

/* ------------------------------------ */
/*              PRODUCT LOGO            */
/* ------------------------------------ */
export const getProductLogo = (): string => {
  const env = getCurrentEnvironment()
  console.log('env: ', process.env.REACT_APP_LOCAL_DB)

  switch (env) {
    //------ HotelX ------- //
    case 'promenadeuat':
    case 'promenade':
    case 'prod':
    case 'noble':
    case 'asia':
    case 'demo':
    case 'training':
    case 'staging':
      return HotelXLogo

    //------ ContractX ------- //
    case 'prod-ent':
    case 'ent-uat':
    case 'ent-train':
      return ContractXLogo

    //------ AccountX ------- //
    case 'local':
    case 'local-dev':
    case 'dev-time':
    case 'azure':
    case 'internal':
    case 'axifcadev':
    case 'trial-migration':
    default:
      return AccountXLogo
  }
}

/* ------------------------------------ */
/*              PRODUCT NAME            */
/* ------------------------------------ */
export const getProductName = (): string => {
  const env = getCurrentEnvironment()

  switch (env) {
    //------ HotelX ------- //
    case 'promenadeuat':
    case 'promenade':
    case 'prod':
    case 'noble':
    case 'asia':
    case 'demo':
    case 'training':
    case 'staging':
      return 'HotelX'

    //------ ContractX ------- //
    case 'prod-ent':
    case 'ent-uat':
    case 'ent-train':
      return 'ContractX'

    //------ AccountX ------- //
    case 'local':
    case 'local-dev':
    case 'dev-time':
    case 'azure':
    case 'internal':
    case 'axifcadev':
    case 'trial-migration':
    default:
      return 'AccountX'
  }
}

/* ------------------------------------ */
/*           PRODUCT SHORT NAME         */
/* ------------------------------------ */
export const getProductShortName = (): string => {
  const env = getCurrentEnvironment()

  switch (env) {
    //------ HotelX ------- //
    case 'promenadeuat':
    case 'promenade':
    case 'prod':
    case 'noble':
    case 'asia':
    case 'demo':
    case 'training':
    case 'staging':
      return 'HX'

    //------ ContractX ------- //
    case 'prod-ent':
    case 'ent-uat':
    case 'ent-train':
      return 'CX'

    //------ AccountX ------- //
    case 'local':
    case 'local-dev':
    case 'dev-time':
    case 'azure':
    case 'internal':
    case 'axifcadev':
    case 'trial-migration':
    default:
      return 'AX'
  }
}

export const getProductConfig = (): ProductConfig => {
  return {
    logo: getProductLogo(),
    name: getProductName(),
    shortName: getProductShortName(),
  }
}

/* ------------------------------------ */
/*            PRODUCT FAVICON           */
/* ------------------------------------ */
export const getProductFavicon = (): string => {
  const env = getCurrentEnvironment()

  switch (env) {
    //------ HotelX ------- //
    case 'promenadeuat':
    case 'promenade':
    case 'prod':
    case 'noble':
    case 'asia':
    case 'demo':
    case 'training':
    case 'staging':
      return 'favicon-hx.ico'

    //------ ContractX ------- //
    case 'prod-ent':
    case 'ent-uat':
    case 'ent-train':
      return 'favicon-cx.ico'

    //------ AccountX ------- //
    case 'local':
    case 'local-dev':
    case 'dev-time':
    case 'azure':
    case 'internal':
    case 'axifcadev':
    case 'trial-migration':
    default:
      return 'favicon.ico'
  }
}

// The product branding based on environment
export const initProductBranding = (): void => {
  const productName = getProductName()
  const favicon = getProductFavicon()

  document.title = productName

  const link: HTMLLinkElement =
    document.querySelector("link[rel~='icon']") ||
    document.createElement('link')
  link.rel = 'icon'
  link.href = `${process.env.PUBLIC_URL}/${favicon}`
  document.head.appendChild(link)
}
